export default function(variable = null)
{
  if (typeof variable == 'undefined' || variable == null) { return 0; }
  if (Array.isArray(variable)) {
    return variable.length;
  }
  return 0;
}